import React from 'react';

import Header from '../../layout/Header.jsx';
import ListRankings from '../../lists/ListRankings.jsx';

const PageRankings = () => (
  <div>
    <Header>Rankings</Header>
    <ListRankings />
  </div>
);

export default PageRankings;
